// extracted by mini-css-extract-plugin
export default {"loader":"SmallLoader_loader__0WLsQ","rotation":"SmallLoader_rotation__t7hFk"};